let state = 0;

export const getState = () => {
  return state;
};

export const setState = (newState) => {
  state = newState;
};